module.exports = __webpack_public_path__ + "img/ck5.609cfe68.png";